<template>

  <v-card class="driver-status-card" v-if="user" @click="itemClicked">
    <v-card-title>
      <div>{{ user.first_name }} {{ user.last_name }}</div>
    </v-card-title>

    <v-card-text>
      <div class="not-set-up-badge" v-if="missingDriverInfo">
        Profile Not Set Up
      </div>
    </v-card-text>
  </v-card>

</template>

<script>
export default {
  name: 'DriverStatusCard',

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  computed: {
    missingDriverInfo () {
      return (
        !this.user.drivers_license_number ||
        !this.user.drivers_license_state_code ||
        !this.user.drivers_license_issue_date ||
        !this.user.drivers_license_expiration ||
        !this.user.fa_license_number ||
        !this.user.fa_license_issue_date ||
        !this.user.fa_license_expiration ||
        !this.user.saved_signature
      )
    }
  },

  methods: {
    itemClicked () {
      this.$emit('itemClicked', this.user)
    }
  }
}
</script>

<style scoped>
  .driver-status-card {
    min-height: 115px;
  }

  .not-set-up-badge {
    font-size: 1.0em;
    font-weight: 600;
    width: 140px;
    padding: 0;
    text-align: center;
    border-radius: 3px;
    color: #ffffff;
    background-color: #FF5D67;
  }
</style>
